//api.js
import service from './request'
import qs from 'qs'
//救援机构
export const logout = data => {//退出接口
    return service({
        url: 'rescue/user/logout',
        method: 'post',
        data
    })
};
export const seversList = data => {//服务流程接口
    return service({
        url: 'rescue/service_plan/level_service',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getnowCase = data => {//获取进行中的案件
    return service({
        url: 'rescue/case/all_ongoing_case',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getCaseNum = data => {//获取每个类型案件的数量
    return service({
        url: 'rescue/case/batch_case_count?status=140&status=150&status=160&status=180',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getCompleteCase = data => {//获取已完成案件
    return service({
        url: 'rescue/case/get_finish_case',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getwaitingCaseNum = data => {//指挥中心每个类型案件的数量
    return service({
        url: 'rescue/case/waiting_case_count?status=140&status=150&status=160&status=180',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getCaseMoneydetails = data => {//回复方案及报价详情接口
    return service({
        url: 'rescue/bidding/bid_bill',
        method: 'post',
        data:qs.stringify(data)
    })
};
// export const loginApi = data => {//登录
//     return service({
//         url: 'rescue/user/login',
//         method: 'post',
//         data:qs.stringify(data)
//     })
// };
export const loginApi = data => {//登录
    return service({
        url: 'rescue/user/usrLogin',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getNodeData = data => {//
    return service({
        url: 'rescue/bidding/view_insti_solution',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getCasedetail= data => {//案件详情
    return service({
        url: 'rescue/case/detail_case',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getCasedetail1= data => {//案件详情 指挥中心
    return service({
        url: 'rescue/case/detail_case_center',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const searchCase= data => {//指挥中心 案件搜索
    return service({
        url: 'rescue/case/search_case',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getLunxun= data => {//轮询
    return service({
        url: 'rescue/notice/unread_list',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getLunxunRead= data => {//轮询
    return service({
        url: '/rescue/notice/set_read',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getFinishCase= data => {//获取完成
    return service({
        url: 'rescue/case/list_closed_case?status=110&status=111&status=113&status=190',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const list_closed_case= data => {//获取完成
  return service({
      url: 'rescue/case/list_closed_case',
      method: 'post',
      data:qs.stringify(data)
  })
};

//监管机构
export const getCaseNum1 = data => {//获取每个类型案件的数量
    return service({
        url: 'rescue/case/batch_case_count?status=120&status=130&status=140&status=150&status=160&status=180',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getnowCaseRegulator = data => {//获取进行中的案件
    return service({
        url: 'rescue/case/regulationGoingCase',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getNodeDataRegulator = data => {//
    return service({
        url: 'rescue/bidding/view_case_solution',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listAttach = data => {
  return service({
      url: 'rescue/case/v2/info/listAttach',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const saveCaseRescueInfo = data => {
  return service({
      url: 'rescue/case/v2/info/saveCaseRescueInfo',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const delCaseRescueInfo = data => {
  return service({
      url: 'rescue/case/v2/info/delCaseRescueInfo',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const saveXingShiInfo = data => {
  return service({
      url: 'rescue/case/v2/info/saveXingShiInfo',
      method: 'post',
      data:qs.stringify(data)
  })
};

export const listCaseFee = data => {
  return service({
      url: 'rescue/case/v2/info/listCaseFee',
      method: 'post',
      data:qs.stringify(data)
  })
};

export const saveCaseFee = data => {
  return service({
      url: 'rescue/case/v2/info/saveCaseFee',
      method: 'post',
      data:qs.stringify(data)
  })
};

export const listXingShiInfo = data => {
  return service({
      url: 'rescue/case/v2/info/listXingShiInfo',
      method: 'post',
      data:qs.stringify(data)
  })
};

export const centerEditCaseFee = data => {
  return service({
      url: 'rescue/case/v2/centerEditCaseFee',
      method: 'post',
      data:qs.stringify(data)
  })
};

export const listRescueInfo = data => {
  return service({
      url: 'rescue/case/v2/info/listRescueInfo',
      method: 'post',
      data:qs.stringify(data)
  })
};

//指挥中心
export const postSubmitauthor = data => {//
    return service({
        url: 'rescue/bidding/submit_author',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getfinishSureCase = data => {//指挥中心确认完成
    return service({
        url: 'rescue/case/centerFinish',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getallGoingCase = data => {//指挥中心进行中案件
    return service({
        url: 'rescue/case/allGoingCase',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getCaseNum2 = data => {//获取每个类型案件的数量
    return service({
        url: 'rescue/case/batch_case_count?&status=100&status=120&status=130&status=140&status=150&status=160&status=180&status=190',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const creatCase = (data,data1) => {//指挥中心确认完成
    return service({
        url: 'rescue/case/create?'+data1,
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getfinishCase = data => {//完成咨询案件
    return service({
        url: 'rescue/case/monitor_finish_case',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getAwaitData = data => {//完成咨询案件
    return service({
        url: 'rescue/case/list_case',
        method: 'post',
        data:qs.stringify(data)
    })
};
// //韩闪
// export const addSubUser = data => {//星使 创建国内协调人
//     return service({
//         url: 'rescue/user/add_sub_user',
//         method: 'post',
//         data:qs.stringify(data)
//     })
// };

//监控普通类案件
export const getOrdinaryCase = data => {//400 需回访确认
    return service({
        url: 'rescue/case/monitor_normal_case',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const updataOrdinaryCase = (data,data1) => {//创建&补充&确认 案件
    return service({
        url: 'rescue/case/monitor_update_case?'+data1,
        method: 'post',
        data:qs.stringify(data)
    })
};
export const closeOrdinaryCase = data => {//关闭案件
    return service({
        url: 'rescue/case/close',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const detailOrdinaryCase = data => {//案件详情
    return service({
        url: 'rescue/case/monitor_detail_case',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getOrdinaryCaseGoing = data => {//监控咨询类案件
    return service({
        url: 'rescue/case/monitor_consult_case',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getCaseNode = data => {//服务节点
    return service({
        url: 'rescue/case/monitor_update_point',
        method: 'post',
        data:qs.stringify(data)
    })
};

//统计图
export const getstatisticalData = data => {
    return service({
        url: 'rescue/case/completed_stat',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getstatisticalMonthCase = data => {
    return service({
        url: 'rescue/case/complete_monthCase',
        method: 'post',
        data:qs.stringify(data)
    })
};


export const postCooperation = data => {
    return service({
        url: 'rescue/user/build_cooperation',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const gethistoryCaseMsg = data => { //获取历史聊天记录
    return service({
        url: 'rescue/case/historyCaseMsg',
        method: 'post',
        data:qs.stringify(data)
    })
};
//map
export const getlistByContinent = data => {//国家列表
    return service({
        url: 'http://api.dajiuxing.com.cn/rescue/screen/listByContinent',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getlistCountryDetail = data => {//国家详情
    return service({
        url: 'http://api.dajiuxing.com.cn/rescue/screen/listCountryDetail',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getlistCountryCode = data => {//服务商
    return service({
        url: 'http://api.dajiuxing.com.cn/rescue/screen/listOperatingInstiByCountryCode',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getlistCountryCodeXs = data => {//星使
    return service({
        url: 'http://api.dajiuxing.com.cn/rescue/screen/listOperatingXSByCountryCode',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getInstituteDetail = data => {//国家详情
    return service({
        url: 'rescue/screen/getInstituteDetail',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getXSDetail = data => {//国家详情
    return service({
        url: 'rescue/screen/getXSDetail',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getAddxingshi = data => {//加入星使
    return service({
        url: 'rescue/case/addUserOrder',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const  getSearchUser= data => {//加入星使
    return service({
        url: 'rescue/case/searchUser',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const  getSearchAddr= data => {//加入星使
    return service({
        url: 'rescue/case/searchAddr',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const  getMissionsOverseas= data => {//加入星使
    return service({
        url: 'rescue/screen/getMissionsOverseas',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const  searchInsurPolicy= data => {//查询保单
    return service({
        url: 'rescue/case/getPolicies',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const  changeLanguage= data => {//查询保单
    return service({
        url: 'rescue/user/trans',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const  searchAddrCode= data => {//地图查询
    return service({
        url: 'rescue/case/searchAddr',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const  searchAddrByGps= data => {//查询保单
    return service({
        url: 'rescue/case/searchAddrByGps',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const  uploadCnts= data => {//
    return service({
        url: 'rescue/case/upload_cnts',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const  connectedCaseList= data => {//
    return service({
        url: 'rescue/case/connected_case_list',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const  caseProgress= data => {//案件流程节点
    return service({
        url: 'rescue/case/case_progress',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const  getCaseConnectedIMGroups= data => {//获取联系人
    return service({
        url: 'rescue/case/getCaseConnectedIMGroups',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listBidding= data => {//获取报价
    return service({
        url: 'rescue/bidding/list_bidding',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const matchProvidersByKey= data => {//搜索星使
    return service({
        url: 'rescue/case/matchProvidersByKey',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listUnassignedCase= data => {//
    return service({
        url: 'rescue/case/list_unassigned_case',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listSubUser= data => {//监管子渠道
    return service({
        url: 'rescue/case/list_sub_user',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const assignSubRegulator= data => {//设置分配公司
    return service({
        url: 'rescue/case/assign_sub_regulator',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const  getVideoList= data => {//群聊案件视频接口
    return service({
        url: 'rescue/case/settled_case_msg_group',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const  getChatRecordSingle= data => {//案件的个人聊天记录
    return service({
        url: 'rescue/case/settled_case_msg_single',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const  getChatRecordGroup= data => {//案件的群聊聊天记录
    return service({
        url: 'rescue/case/settled_case_msg_group',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const  getAnjianList= data => {//归档案件列表
    return service({
        url: 'rescue/case/case_upload_cnts',
        method: 'post',
        data:qs.stringify(data)
    })
};

export const  uploadFile= data => {//文件上传附件
    return service({
        url: 'rescue/case/create_upload_cnt',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const  saveCaseTrack= data => {//案件轨迹列表
  return service({
      url: 'rescue/case/v2/info/saveCaseTrack',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const  listTrack= data => {//案件轨迹列表
  return service({
      url: 'rescue/case/v2/info/listTrack ',
      method: 'post',
      data:qs.stringify(data)
  })
};

export const addContactsCase= data => {//群组加人
    return service({
        url: 'rescue/case/add_contacts_case',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const subUserList= data => {//获取子用户列表
    return service({
        url: 'rescue/case/list_sub_user',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const addSubUser= data => {//添加子账号
    return service({
        url: 'rescue/user/add_sub_user',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const freezeSubUser= data => {//冻结子账户
    return service({
        url: 'rescue/user/status_sub_user',
        method: 'post',
        data:qs.stringify(data)
    })
};

//分支机构
export const getAllCoordinatedCases = data => {// 星使
    return service({
        url: 'rescue/case/allCoordinatedCases',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getCaseNum3 = data => {//获取每个类型案件的数量
    return service({
        url: 'rescue/case/batch_case_count?status=200&status=210&status=211&status=230',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const xsApproveLst = data => {//等待审核的星使案件列表
    return service({
        url: 'rescue/case/xs_approve_lst',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const authorize = data => {//派单审核
    return service({
        url: 'rescue/xingshi/authorize',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const xingshiGong = (data,data1) => {//星使派单 进行中案件
    return service({
        url: 'rescue/case/list_case?'+data1,
        method: 'post',
        data:qs.stringify(data)
    })
};
export const finishXingshiGong = (data,data1) => {//星使派单 已完成案件
    return service({
        url: 'rescue/case/list_case?'+data1, //114,115
        method: 'post',
        data:qs.stringify(data)
    })
};
export const pstnCallLst = data => {//获取未关联的录音列表
    return service({
        url: 'rescue/case/pstn_call_lst',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const addbrief = data => {//添加简报
    return service({
        url: 'rescue/xingshi/addbrief',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const searchBasic = data => {//查询出险人手机号
    return service({
        url: 'rescue/xingshi/search_basic',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const creatBasic = data => {//创建大救星ID
    return service({
        url: 'rescue/xingshi/create_basic',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listDomestic = data => {//获取参与案件的国内协调人列表ID
    return service({
        url: 'rescue/xingshi/list_domestic',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getPolicies = data => {//查询保单
    return service({
        url: 'rescue/case/getPolicies',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const addDomestic = (data,data1) => {//加入协调
    return service({
        url: 'rescue/xingshi/add_domestic?'+data1,
        method: 'post',
        data:qs.stringify(data)
    })
};
export const removeDomestic = (data,data1) => {//查询保单
    return service({
        url: 'rescue/xingshi/remove_domestic?'+data1,
        method: 'post',
        data:qs.stringify(data)
    })
};
export const diffDomestic = (data,data1,data2) => {//删除保单
    return service({
        url: 'rescue/xingshi/diff_domestic?'+data1 + data2,
        method: 'post',
        data:qs.stringify(data)
    })
};
export const closeCase = data => {//关闭
    return service({
        url: 'rescue/case/close',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const caseCountNum = (data,data1) => {//星使案件数量
    return service({
        url: 'rescue/case/case_count?'+data1,
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getCounties = data => {//城市查询
    return service({
        url: 'rescue/case/counties',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const smsOperation = data => {//监管授权发送验证短信
    return service({
        url: '/rescue/user/smsOperation',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listNormalUser = data => {//设置非公司隶属的协调人列表
    return service({
        url: 'rescue/case/list_normal_user',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const centerFinishRescue = data => {//设置非公司隶属的协调人列表
  return service({
      url: 'rescue/case/v2/centerFinishRescue',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const centerStartRescue = data => {//设置非公司隶属的协调人列表
  return service({
      url: 'rescue/case/v2/centerStartRescue',
      method: 'post',
      data:qs.stringify(data)
  })
};

export const diffNormalUser = (data,data1) => {//设置非公司隶属的协调人
    return service({
        url: 'rescue/case/diff_normal_user?'+data1,
        method: 'post',
        data:qs.stringify(data)
    })
};
export const listAccessingCase = data => {//待认定保险责任清单
    return service({
        url: 'rescue/case/list_accessing_case',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const accessCaseLiability = data => {//认定保险责任的接口
    return service({
        url: 'rescue/case/access_case_liability',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const noticeAccessCaseLiability = data => {//通知认定保险责任
    return service({
        url: 'rescue/case/notice_access_case_liability',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const joinCoord = data => {//设置加入协调
    return service({
        url: 'rescue/xingshi/join_coord',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const authorizeRescueStart = data => {//授权该救援机构开始救援
    return service({
        url: 'rescue/bidding/authorize_rescue_start',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const updateBiddingState = data => {//关闭案件
    return service({
        url: 'rescue/bidding/update_bidding_state',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const getCenterFinishCase = data => {//指挥中心已完成案件
    return service({
        url: 'rescue/case/get_center_finish_case',
        method: 'post',
        data:qs.stringify(data)
    })
};
export const searchLocByHit = data => {//地图搜索
    return service({
        url: 'rescue/notice/searchLocByHit',
        method: 'post',
        data:qs.stringify(data)
    })
};

export const rescue_offlineinsurelist = data => {//线下保单查询列表
  return service({
      url: 'spring/rescue/offline_insure/list',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const rescue_offlineinsuredel = data => {//线下保单查询列表删除
  return service({
      url: 'spring/rescue/offline_insure/deleteById',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const rescueoffline_insurequery = data => {//线下保单查询
  return service({
      url: 'spring/rescue/offline_insure/query',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const userlist_regulator = data => {//保险机构列表
  return service({
      url: 'rescue/user/listSubRegulators',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const  listSubRegulators= data => {//保险机构列表
  return service({
      url: 'rescue/user/list_regulator',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const userwAddRegulators = data => {//保险机构添加编辑
  return service({
      url: 'rescue/user/addOrEditSubRegulators',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const userdelSubRegulator = data => {//删除子保险公司
  return service({
      url: 'rescue/user/delSubRegulator',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const usersendCaseMail = data => {//发邮件给保险公司
  return service({
      url: 'rescue/case/sendCaseMail',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const caseexport_caseManage_List = data => {//家财险导出
  return service({
      url: 'rescue/case/export_caseManage_List',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const caselist_case_info = data => {//家财险草稿列表
  return service({
      url: 'rescue/case/list_case_info',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const casecreateEditTempCase = data => {//家财险草稿保存
  return service({
      url: 'rescue/case/createEditTempCase',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const rescuecasecase_info = data => {//家财险详情
  console.log(data)
  return service({
      url: 'rescue/case/case_info',
      method: 'post',
      data:qs.stringify(data)
  })
};

export const casedel_case_info = data => {//家财险删除
  console.log(data)
  return service({
      url: 'rescue/case/del_case_info',
      method: 'post',
      data:qs.stringify(data)
  })
};

export const caselist_case_record = data => {//日志列表
  console.log(data)
  return service({
      url: 'rescue/case/list_case_record',
      method: 'post',
      data:qs.stringify(data)
  })
};

export const update_case_state = data => {//平安家财险数据列表状态更新
  return service({
      url: '/rescue/pcase/updateCaseState',
      method: 'post',
      data:qs.stringify(data)
  })
};
export const export_caseManage_List = data => {//导出
  return service({
      url: '/rescue/case/export_caseManage_List?token=' + data.token + '&incidentType=800&startTs=' + data.startTs + '&endTs=' + data.endTs + '&regulatorId=' + data.regulatorId + '&subRegulatorId=' + data.subRegulatorId + '&reportUser=' + data.reportUser + '&accidentType=' +data.accidentType + '&victimUser=' + data.victimUser + '&victimPolicyNo=' + data.victimPolicyNo + '&victimNational=' + data.victimNational + '&reporterContact=' + data.reporterContact + '&caseNo=' + data.caseNo  + '&jtOrderId=' + data.jtOrderId + data.statustxt ,
      method: 'get',
      // data:qs.stringify(data)
  })
};
export const export_caseManage_List2 = data => {//导出
  return service({
      url: '/rescue/case/export_caseManage_List?token=' + data.token + '&incidentType=800&startTs=' + data.startTs + '&endTs=' + data.endTs + '&regulatorId=' + data.regulatorId + '&subRegulatorId=' + data.subRegulatorId + '&reportUser=' + data.reportUser + '&accidentType=' +data.accidentType + '&victimUser=' + data.victimUser + '&victimPolicyNo=' + data.victimPolicyNo + '&victimNational=' + data.victimNational + '&reporterContact=' + data.reporterContact + '&caseNo=' + data.caseNo + '&jtOrderId=' + data.jtOrderId + '&status=110&status=111&status=113',
      method: 'get',
      // data:qs.stringify(data)
  })
}
export const export_caseManage_List1 = data => {//导出
  return service({
      url: '/rescue/case/export_caseManage_List?token=' + data.token + '&incidentType=800&startTs=' + data.startTs + '&endTs=' + data.endTs + '&regulatorId=' + data.regulatorId + '&subRegulatorId=' + data.subRegulatorId + '&reportUser=' + data.reportUser + '&accidentType=' +data.accidentType + '&victimUser=' + data.victimUser + '&victimPolicyNo=' + data.victimPolicyNo + '&victimNational=' + data.victimNational + '&reporterContact=' + data.reporterContact + '&caseNo=' + data.caseNo + data.statustxt + '&instiEndTsEnd=' + data.instiEndTsEnd + '&instiEndTsBegin=' + data.instiEndTsBegin + '&jtOrderId=' + data.jtOrderId,
      method: 'get',
      // data:qs.stringify(data)
  })
};
export const rescuesaleexportlist = data => {///导出记录
  return service({
    url: '/rescue/export/list',
    method: 'post',
    data:qs.stringify(data)
  })
};
export const casespecialCaseState = data => {///标星
  return service({
    url: '/rescue/case/specialCaseState ',
    method: 'post',
    data:qs.stringify(data)
  })
};
export const listReceivableFee = data => {///标星
  return service({
    url: 'rescue/case/v2/info/listReceivableFee',
    method: 'post',
    data:qs.stringify(data)
  })
};

export const saveReceivableFee = data => {///标星
  return service({
    url: '/rescue/case/v2/info/saveReceivableFee',
    method: 'post',
    data:qs.stringify(data)
  })
};

export const rescuecasefindrescueinsti = data => {///救援公司
  return service({
    url: '/rescue/case/find-rescue-insti',
    method: 'post',
    data:qs.stringify(data)
  })
};
export const caseregulatorsave = data => {///类型添加
  return service({
    url: '/rescue/case/regulator/save',
    method: 'post',
    data:qs.stringify(data)
  })
};
export const regulatorfindservicetype = data => {///获取类型
  return service({
    url: '/rescue/case/regulator/find-service-type',
    method: 'post',
    data:qs.stringify(data)
  })
};
export const regulatorsaveService = data => {///获取类型
  return service({
    url: 'rescue/case/regulator/saveService',
    method: 'post',
    data:qs.stringify(data)
  })
};
export const regulatorlistservice = data => {///获取类型
  return service({
    url: 'rescue/case/regulator/list-service',
    method: 'post',
    data:qs.stringify(data)
  })
};
export const wGetContract = data => {///获取类型
  return service({
    url: 'rescue/user/wGetContract',
    method: 'post',
    data:qs.stringify(data)
  })
};

export const sendCaseSMS = data => {///发送短信给紧急联系人
  return service({
    url: 'rescue/case/sendCaseSMS',
    method: 'post',
    data:qs.stringify(data)
  })
};

export const restart_rescue_case = data => {///重启救援案件
  return service({
    url: 'rescue/bidding/restart_rescue_case',
    method: 'post',
    data:qs.stringify(data)
  })
};

export const listChargePerson = data => {
  return service({
    url: 'rescue/case/list_charge_person',
    method: 'post',
    data: qs.stringify(data)
  })
};


export const exportFinishCaseList = data => {
  return service({
    url: '/rescue/case/export_caseManage_List?token=' + data.token + '&incidentType=800&startTs=' + data.startTs + '&endTs=' + data.endTs + '&caseNo=' + data.caseNo + data.statustxt,
    method: 'get'
  })
};









// WEBPACK FOOTER //
// ./src/views/axios/api.js